/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlBrokerInviteRequest
 */
export interface ControlBrokerInviteRequest {
    /**
     * 
     * @type {string}
     * @memberof ControlBrokerInviteRequest
     */
    email: string;
}

/**
 * Check if a given object implements the ControlBrokerInviteRequest interface.
 */
export function instanceOfControlBrokerInviteRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "email" in value;

    return isInstance;
}

export function ControlBrokerInviteRequestFromJSON(json: any): ControlBrokerInviteRequest {
    return ControlBrokerInviteRequestFromJSONTyped(json, false);
}

export function ControlBrokerInviteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlBrokerInviteRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function ControlBrokerInviteRequestToJSON(value?: ControlBrokerInviteRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
    };
}

